import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const LargeDivider = styled.div`
  height: ${Spacing.S4};
  margin: 0 -${Spacing.S24} 0 -${Spacing.S24}; /* Compensate for Drawer padding to make the divider full width */
  background-color: ${Color.Grey150};
`
